<template>
  <transition name="">
    <section class="opinion_search active" id="project-comment">
      <h2 class="hide">의견 작성 레이어</h2>
      <button type="button" class="opinion_search_closed"></button>
      <div class="opinion-search_area">
        <div class="opinion-search_area">
          <input type="text" required 
            ref="searchInput"
            @input="searchComment"
            @keydown="searchComment"
            @keyup="searchComment"
            :placeholder="$i18nUtil.trans('message.placeholder.select.comment','작성자, 의견내용을 검색하세요.')">
          <button type="reset"
            @click="searchComment"
            class="btn_search">
            검색
          </button>
          <div class="list scroll hidden">
            <!-- <memberSearchList/> -->
          </div>
        </div>
      </div>
      <div ref="scrollBox" class="scroll_box writebox">
        <div ref="commentPanel">
          <div class="no-data" v-if="commentList.length == 0" v-html="$i18nUtil.trans('message.ProjectComment.002','작성된 의견이 없습니다. 과제에 대한 다양한 의견을 남겨보세요.')">
          </div>
          <div
            class="opinion_box"
            v-for="item in commentList"
            v-show="searchFilter(item)"
            :class="item.deleteYn ? 'del' : ''"
            :key="'comment' + item.commentId"
            :data-comment-id="item.commentId"
            >
            <template v-if="!item.deleteYn">
            <div class="name">
              <div class="droplayer relative">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn 
                        v-bind="attrs" 
                        v-on="on">
                        <b v-html="highlight(item.regUserName)"></b>
                      </v-btn>
                    </template>
                    <div class="dropdown-list">
                      <UserTooltip :userId="item.regUserId" />
                    </div>
                  </v-menu>
                </div>
                <span class="date">
                  {{ $moment(item.regDate).format("YYYY.MM.DD HH:mm") }}
                </span>
              </div>
              <!--의견수정폼-->
              <div
                class="opinion-input_ty1 hidden"
                :ref="'commentEditBox' + item.commentId">
                <div
                  class="textarea"
                  :ref="'commentEditForm' + item.commentId"
                  contenteditable
                  @keydown="commentKeyDown($event, item.commentId)"
                  @keyup="commentKeyUp($event, item.commentId)"
                  @blur="commentBlur($event, 'update', item.commentId)"
                  v-html="html(item.comment)">
                </div>
                <div class="btn_box txtr hidden" :ref="'commentBtnBar' + item.commentId">
                  <div class="message hidden" :ref="'warnMsg' + item.commentId">
                    <span class="error">{{ $i18nUtil.trans("message.ProjectComment.003","입력 가능한 글자수를 초과하였습니다.") }}</span> <span class="count">(<b>{{state.inputLength}}</b>/500)</span>
                  </div>
                  <div class="message hidden" :ref="'warnMsg' + item.commentId">
                    <span class="error">{{ $i18nUtil.trans("message.ProjectComment.004","의견 내용이 너무 짧습니다.") }}</span> <span class="count">(<b>{{state.inputLength}}</b>)</span>
                  </div>
                  <button
                    type="button"
                    class="btn-txt-primary"
                    @click="viewHidden('update', item.commentId, true)">
                    {{ $i18nUtil.trans("button.cancel","취소") }}
                  </button>
                  <button
                    type="button"
                    class="btn-txt-primary black"
                    @click="updateComment(item)">
                    {{ $i18nUtil.trans("button.modify","수정") }}
                  </button>
                </div>
              </div>
              <!--/의견수정폼-->
              <!--수정삭제버튼-->
              <div class="btn_box top" v-if="chkUser(item)">
                <button
                  type="button"
                  class="btn-ico-del_ty1"
                  @click="deleteCommentModal(item)">
                  {{ $i18nUtil.trans("button.delete","삭제") }}
                </button>
                <button
                  type="button"
                  class="btn-ico-edit"
                  @click="viewHidden('update', item.commentId)">
                  {{ $i18nUtil.trans("button.modify","수정") }}
                </button>
              </div>
              <!--/수정삭제버튼-->
              <!--의견내용-->
              <div
                :ref="'commentEditBox' + item.commentId"
                class="txt"
                v-html="highlight(item.comment)">
              </div>
              <!--/의견내용-->
            </template>
            <template v-else>
              <div class="txt">
                {{ $i18nUtil.trans("message.ProjectComment.005","삭제된 의견입니다.") }}
              </div>
            </template>
            <dl class="reply_box" v-if="item.commentCount > 0">
              <dt class="active"
                @click="viewHidden('write', item.commentId)" 
                v-html="$i18nUtil.trans('search.000.reply','총 {cnt} 건의 답변', {cnt: item.commentCount})">
              </dt>
              <dd>
                <div
                  v-for="reply in commentMap[item.commentId].replyList"
                  :key="'reply' + reply.commentId"
                  :data-comment-id="reply.commentId"
                  v-show="searchFilter(reply)">
                  <div class="opinion_box"
                    :class="reply.deleteYn ? 'del' : ''">
                    <template v-if="!reply.deleteYn">
                      <div class="name">
                        <div class="droplayer relative">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn 
                                v-bind="attrs" 
                                v-on="on">
                                <b v-html="highlight(reply.regUserName)"></b>
                              </v-btn>
                            </template>
                            <div class="dropdown-list">
                              <UserTooltip :userId="reply.regUserId" />
                            </div>
                          </v-menu>
                        </div>
                        <span class="date">
                          {{ $moment(reply.regDate).format("YYYY.MM.DD HH:mm") }}
                        </span>
                        <div class="btn_box top" v-if="chkUser(reply)">
                          <button
                            type="button"
                            class="btn-ico-del_ty1"
                            @click="deleteCommentModal(reply)">
                            {{ $i18nUtil.trans("button.delete","삭제") }}
                          </button>
                          <button
                            type="button"
                            class="btn-ico-edit"
                            @click="viewHidden('update', reply.commentId)">
                            {{ $i18nUtil.trans("button.modify","수정") }}
                          </button>
                        </div>
                      </div>
                      <div
                        :ref="'commentEditBox' + reply.commentId"
                        class="txt"
                        v-html="highlight(reply.comment)">
                      </div>
                      <div
                        :ref="'commentEditBox' + reply.commentId"
                        class="opinion-input_ty1 hidden"
                        >
                        <div
                          class="textarea editor reply"
                          :ref="'commentEditForm' + reply.commentId"
                          contenteditable
                          @keydown="commentKeyDown($event, reply.commentId)"
                          @keyup="commentKeyUp($event, reply.commentId)"
                          @blur="commentBlur($event, 'update', reply.commentId)"
                          style="display: block"
                          v-html="html(reply.comment)">
                        </div>
                        <div class="btn_box txtr hidden" :ref="'commentBtnBar' + reply.commentId">
                          <div class="message hidden" :ref="'warnMsg' + reply.commentId">
                            <span class="error">{{ $i18nUtil.trans("message.ProjectComment.003","입력 가능한 글자수를 초과하였습니다.") }}</span> <span class="count">(<b>{{state.inputLength}}</b>/500)</span>
                          </div>
                          <div class="message hidden" :ref="'warnMsg' + reply.commentId">
                            <span class="error">{{ $i18nUtil.trans("message.ProjectComment.004","의견 내용이 너무 짧습니다.") }}</span> <span class="count">(<b>{{state.inputLength}}</b>)</span>
                          </div>
                          <button
                            type="button"
                            class="btn-txt-primary"
                            @click="viewHidden('update', reply.commentId, true)">
                            {{ $i18nUtil.trans("button.cancel","취소") }}
                          </button>
                          <button
                            type="button"
                            class="btn-txt-primary black"
                            @click="updateComment(reply)">
                            {{ $i18nUtil.trans("button.modify","수정") }}
                          </button>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <div class="txt">
                        {{ $i18nUtil.trans("message.ProjectComment.008","삭제된 답변입니다.") }}
                      </div>
                    </template>
                  </div>
                </div>
              </dd>
            </dl>
            <div 
              :ref="'commentWriteBox' + item.commentId"
              class="opinion-input_ty1 hidden">
              <div
                :ref="'usageMsgR' + item.commentId"
                class="block-usage textarea placeholder"
                @mousemove="commentMouseMove($event, 'write', item.commentId)"
                @mouseout="commentMouseMove($event, 'write', item.commentId)"
                @click="commentFocus($event, item.commentId)">
                {{ $i18nUtil.trans("message.ProjectComment.009","답변을 입력하고 @사용자이름으로 대상자를 지정하세요") }}
              </div>
              <div
                :ref="'commentWriteForm' + item.commentId"
                class="textarea editor"
                @keydown="commentKeyDown($event, 'R' + item.commentId)"
                @keyup="commentKeyUp($event, 'R' + item.commentId)"
                @blur="commentBlur($event, 'write', item.commentId)"
                contenteditable>
              </div>
              <div class="hidden" :ref="'mentionSample' + item.commentId">
                &nbsp;<span class="tag mention" :data-user-id="item.regUserId" :data-user-name="item.regUserName" :data-callEx-id="createFindKey()">@{{item.regUserName}}</span>&nbsp;
              </div>
              <div class="btn_box txtr hidden" :ref="'commentBtnBarR' + item.commentId">
                <div class="message hidden" :ref="'warnMsgR' + item.commentId">
                  <span class="error">{{ $i18nUtil.trans("message.ProjectComment.003","입력 가능한 글자수를 초과하였습니다.") }}</span> <span class="count">(<b>{{state.inputLength}}</b>/500)</span>
                </div>
                <div class="message hidden" :ref="'warnMsgR' + item.commentId">
                  <span class="error">{{ $i18nUtil.trans("message.ProjectComment.004","의견 내용이 너무 짧습니다.") }}</span> <span class="count">(<b>{{state.inputLength}}</b>)</span>
                </div>
                <button
                  type="button"
                  class="btn-txt-primary"
                  @click="viewHidden('write', item.commentId, true)">
                  {{ $i18nUtil.trans("button.cancel","취소") }}
                </button>
                <button
                  type="button"
                  class="btn-txt-primary black"
                  @click="writeComment(item)">
                  {{ $i18nUtil.trans("button.register","등록") }}
                </button>
              </div>
            </div>
            <button
              :ref="'commentWriteBox' + item.commentId"
              type="button"
              class="btn-txt-underline reply"
              v-if="!item.deleteYn"
              @click="viewHidden('write', item.commentId)">
              {{ $i18nUtil.trans("button.answer","답변하기") }}
            </button>
          </div>
          <!-- //opinion_box -->
          <div class="no-data" v-if="commentList.length > 0 && isEmpty">
            {{ $i18nUtil.trans("search.013","검색 결과가 없습니다.") }}<br/>
          </div>
        </div>
      </div>
      <!-- //scroll_box -->
      <div class="write-form">
        <div class="opinion-input_ty1" v-for="inx in [1]" :key="inx">
          <div
            :ref="'usageMsgR'"
            class="block-usage textarea placeholder"
            @mousemove="commentMouseMove($event, 'write', '')"
            @mouseout="commentMouseMove($event, 'write', '')"
            @click="commentFocus($event, '')">
            {{ $i18nUtil.trans("message.placeholder.comment","의견을 입력하고 @사용자이름으로 대상자를 호출하세요.") }}
          </div>
          <div class="textarea "
            :ref="'commentWriteForm'"
            @keydown="commentKeyDown($event, 'R')"
            @keyup="commentKeyUp($event, 'R')"
            @blur="commentBlur($event, 'write', '')"
            contenteditable>
          </div>
          <div class="btn_box txtr hidden" ref="commentBtnBarR">
            <div class="message hidden" :ref="'warnMsgR'">
              <span class="error">{{ $i18nUtil.trans("message.ProjectComment.003","입력 가능한 글자수를 초과하였습니다.") }}</span> <span class="count">(<b>{{state.inputLength}}</b>/500)</span>
            </div>
            <div class="message hidden" :ref="'warnMsgR'">
              <span class="error">{{ $i18nUtil.trans("message.ProjectComment.004","의견 내용이 너무 짧습니다.") }}</span> <span class="count">(<b>{{state.inputLength}}</b>)</span>
            </div>
            <button
              type="button"
              class="btn-txt-primary"
              @click="viewHidden('write', '', true)">
              {{ $i18nUtil.trans("button.cancel","취소") }}
            </button>
            <button
              type="button"
              class="btn-txt-primary black"
              @click="writeComment('')">
              {{ $i18nUtil.trans("button.register","등록") }}
            </button>
          </div>
        </div>
      </div>
      <!-- [호출멤버 선택기 영역] -->
        <!-- 회사 임직원 전체 조회: searchNonMember === true -->
        <!-- 과제에 속한 멤버만 조회: searchNonMember === false -->
        <MemberListSelector
          id="board-members-selector"
          ref="memberSelector"
          class="hidden"
          :groupId="groupId"
          :height="state.memberListHeight"
          :localUserList="memberList"
          :memberOnly="searchNonMember === false"
          :callLocation="'project'"
        />
      <!-- /[호출멤버 선택기 영역] -->
    </section>
  </transition>
</template>
<script>
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
/* 호출멤버 선택기 */
import MemberListSelector from "../../board/extensions/MemberListSelector";
import SimpleModal from '../../board/modal/SimpleModal.vue';
import lodash from "lodash";
/* codeValue 조회 */
import codeValueJs from '@/js/codeValue/codeValue';

export default {
  components: {
    UserTooltip,
    MemberListSelector
  },
  props: {
    projectId: String,
    groupId: String,
    userId: String,
    memberList: Array,
    callFrom: String,
    toggleBtn: Object,
  },
  data() {
    return {
      searchNonMember: null, /* true: 전체 사용자 검색, false: 속한 멤버만 검색 */
      tenantId: localStorage.getItem('tenantId'),
      state: {
        inputTarget: false,
        inputLength: 0,
        parentObserver: null,
        memberListHeight: 250,
        memberSearchOpen: true,
        blurHandle: false,
        isIE: [ false ],
      },
      commentMap: [],
      commentList: [],
      // 호출 데이터
      writeParam: {
        comment: "",
        paperId: "",
        paperBlockId: "",
        commentId: "",
        delDate: "",
        delUserId: null,
        deleteYn: 0,
        pageNo: 0,
        parentCommentId: "",
        regDate: "",
        regUserId: "",
        regUserName: "",
        versionSeq: "",
        targetUserId: [],
        targetUserName: [],
        callFindKeyMap: {}
      },
      // 리스트에서 체크한 목록
      members: this.memberList,
      search: "",
      isEmpty: true,
      memberSelector: null,
    };
  },
  created() {
    EventBus.$on("project.comment", param => {
      if (param.action != "count" && param.projectId === this.projectId) {
        this.getCommentList();
      }
    });
    // 멤버 호출: 멤버 외 사용자 검색 여부
    this.setSearchNonMember();
  },
  computed: {
    ...mapState("evdControl", ["KEYCODES", "EVENT_TYPES"]),
  },
  mounted() {
    let self = this;
    self.getCommentList({ goto: 1 });
    self.$refs.scrollBox.removeEventListener("scroll", self.scrollCommentList);
    self.$refs.scrollBox.addEventListener("scroll", self.scrollCommentList);
    self.CHECK_IE({res: self.state.isIE});

    self.memberSelector = self.$refs.memberSelector;
    {
      /* 의견창이 닫히면 멤버호출 창도 닫혀야 한다. */
      let parent = self.$el.parentNode.parentNode;
      if (self.state.parentObserver) { self.state.parentObserver.disconnect(); }
      self.state.parentObserver = new MutationObserver((list, obs) => {
        if (parent.style.display === "none") {
          self.memberSelector.cancelMemberSelect(self.state.inputTarget);
          self.memberSelector.cancelMemberSelect(self.$refs.searchInput);
        }
      });
      self.state.parentObserver.observe(parent, { attributes: true });
    }
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    ...mapActions("coworkUtils", ["CHECK_AND_LAUNCH", "CHECK_IE", "HW_KEYGEN"]),
    ...mapActions("evdControl", ["CANCEL_EVENT"]),
    getCommentList(param) {
      let self = this;
      let request = {
        url: "/api/cogroup/project/getCommentList",
        method: "post",
        params: {
          projectId: self.projectId,
        }
      };
      self.COWORK_REST_SIMPLE_ACTION(request).then(resp => {
        if (!resp) { return; }
        if (resp.errorCode) { console.log('/commentList errorCode', resp.errorCode); }
        let result = resp.result;
        self.commentProcess(result, param);
      });
    },
    commentProcess(resultParam, param) {
      let result = resultParam;
      if(this.$i18nUtil.getLanguage() === 'ko') {

      }else{
        result.forEach(rl => {
          rl.regUserName = rl.regUserNameEn != null ? rl.regUserNameEn : rl.regUserName;
        })
      }

      let self = this;
      let commentList = self.commentList;
      let commentMap = self.commentMap;
      commentList.splice(0, commentList.length);
      for (let k in commentMap) { delete commentMap[k]; }
      let fnGetMap = ((commentId, comment) => {
        if (!commentMap[commentId]) {
          commentMap[commentId] = { comment, replyList: [] };
        }
        else if (!comment) {
          comment = commentMap[commentId].comment;
        }
        if (comment) {
          comment.commentCount = commentMap[commentId].replyList.length;
        }
        return commentMap[commentId];
      });
      let count = 0;
      let traceComment = [result[0], result[0]];
      if (!result[0]) {
        traceComment = [{ }, { }];
      }
      for (let inx = 0; result && inx < result.length; inx++) {
        let comment = result[inx];
        if (!comment.deleteYn) { 
          count++; 
          if (comment.regDate > traceComment[0].regDate) {
            traceComment[0] = comment;
          }
        }
        if (!comment.parentCommentId) {
          commentList.push(comment);
          fnGetMap(comment.commentId, comment);
          if (comment.regDate > traceComment[1].regDate) {
            traceComment[1] = comment;
          }
        }
        else {
          let parent = fnGetMap(comment.parentCommentId);
          parent.replyList.push(comment);
          if (parent.comment) {
            parent.comment.commentCount = parent.replyList.length;
          }
          fnGetMap(comment.commentId, comment);
        }
      }

      EventBus.$emit("project.comment", {
        action: "count",
        projectId: self.projectId,
        count: count,
      });

      /* 최초 진입시 가장최근 의견으로 이동 (최하단 으로 스크롤) */
      if (param) {
        if (param.goto === 0) {
          /* 답변포함 최근의견 */
          self.gotoComment(traceComment[0].commentId);
        }
        else if (param.goto === 1) {
          /* 답변제외 최근의견 */
          self.gotoComment(traceComment[1].commentId);
        }
        else {
          /* 직접접근 */
          self.gotoComment(param.goto);
        }
      }
    },
    gotoComment(commentId) {
      let self = this;
      self.CHECK_AND_LAUNCH({ check(ctx) {
        let panelHeight = self.$refs.commentPanel ? self.$refs.commentPanel.offsetHeight : 0;
        let scrollBoxHeight = self.$refs.scrollBox ? self.$refs.scrollBox.offsetHeight : 0;
        if (!ctx.panelHeight || ctx.panelHeight != panelHeight) {
          ctx.panelHeight = panelHeight;
          ctx.scrollBoxHeight = scrollBoxHeight;
          return false;
        }
        return true;
      }, launch(ctx) {
        let scrollTop = 0;
        let diffTop = 95;
        if (self.callFrom === "projectContents") {
          diffTop += 34;
        }
        if (commentId) {
          let list = self.$el.querySelectorAll("[data-comment-id]");
          for (let item of list) {
            if (item.getAttribute("data-comment-id") === commentId) {
              if (self.commentMap[commentId].comment.parentCommentId) {
                scrollTop = item.offsetTop + 
                  item.parentNode.parentNode.parentNode.offsetTop - diffTop - 5;
              }
              else {
                scrollTop = item.offsetTop - diffTop;
              }
              self.$refs.scrollBox.scrollTop = scrollTop;
              // console.log("SCROLL:", scrollTop, self.commentMap[commentId], item);
            }
          }
        }
        else {
          scrollTop = ctx.panelHeight - ctx.scrollBoxHeight + diffTop;
          if (scrollTop < 0) { scrollTop = 0; }
          self.$refs.scrollBox.scrollTop = scrollTop;
          // console.log("SCROLL:", scrollTop);
        }
      }, interval: 200 });
    },
    memberSearchPos(pos, caret) {
      let parent = caret.parentNode;
      let offsetTop = parent.offsetTop;
      let offsetLeft = parent.offsetLeft;
      pos.top = offsetTop - caret.offsetTop + 48;
      pos.left = offsetLeft - caret.offsetLeft + 30;
      pos.reverse = true;
      if (this.callFrom === "projectContents") {
        pos.top += 34;
      }
    },
    memberSearchSelect(cancel, item, caret) {
      let text = item ? item.getAttribute("data-user-name") : "";
      let userInGroup = item ? item.getAttribute("data-user-ingroup") : false;
      if (!cancel && text) {
        this.search = text;
        this.isEmpty = true;
        caret.element.value = text;
      }
    },
    searchComment(e) {
      let self = this;
      let target = e.target;
      let element = self.$refs.searchInput;
      if (target.nodeName === "BUTTON" && element.value) {
        self.memberSelector.cancelMemberSelect(self.$refs.searchInput);
        element.value = "";
        self.search = "";
        self.isEmpty = true;
        self.memberSearchOpen = true;
      }
      else {
        lodash.debounce(() => {
          let search = element.value;
          search = search.replace(/</g, "&lt;").replace(/>/g, "&gt;");
          search = search.replace(/^[  \t\r\n\0]+/, "");
          search = search.replace(/[  \t\r\n\0]+$/, "");
          self.search = search;
          self.isEmpty = true;
        }, 100)();
      }
      let boxcls = self.$refs.scrollBox.classList;
      if (self.search === "" && element.value === "") {
        boxcls.remove("searchbox");
        boxcls.add("writebox");
      }
      else {
        boxcls.remove("writebox");
        boxcls.add("searchbox");
      }
    },
    html(html) {
      let regex = /[<][/]span[>][ \0\r\n]*$/;
      if (regex.exec(html.toLowerCase())) {
        // 멘션태그와 붙는것을 방지.
        html = html + "\&nbsp;";
      }
      return html;
    },
    highlightNode (element, search, caseIgnore) {
      let node = element.firstChild;
      if (search && caseIgnore) {
        search = search.toLowerCase();
      }
      for (let node = element.firstChild;node ; node = node.nextSibling) {
        if (node.nodeName == "#text") {
          let result = "";
          let orig = node.nodeValue;
          let text = orig;
          if (caseIgnore) {
            text = text.toLowerCase();
          }
          let pp = 0;
          for (let cp = 0; (cp = text.indexOf(search, cp)) != -1;) {
            let textNode = document.createTextNode(orig.substring(pp, cp));
            let spanNode = document.createElement("span");
            spanNode.classList.add("highlight");
            spanNode.innerText = orig.substring(cp, cp + search.length);
            element.insertBefore(textNode, node);
            element.insertBefore(spanNode, node);
            cp += search.length;
            pp = cp;
          }
          node.nodeValue = text.substring(pp);
        }
        else {
          this.highlightNode(node, search);
        }
      }
    },
    highlight(text) {
      if (!text) { text = ""; }
      let search = this.search;
      if (search) {
        let element = document.createElement("div");
        element.innerHTML = text;
        this.highlightNode(element, search, true);
        text = element.innerHTML;
      }
      return text;
    },
    searchFilter(comment) {
      let replyList = this.commentMap[comment.commentId].replyList;
      let fncCheck = (comment) => {
        if (!this.search) { return true; }
        if (this.search &&
          comment.deleteYn != 1 && comment.regUserName != null && (
            comment.comment.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            comment.regUserName.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
          )) {
          return true;
        }
        return false;
      };
      let chk = fncCheck(comment);
      if (!chk && replyList.length > 0) {
        for(let inx in replyList) {
          if ((chk = fncCheck(replyList[inx]))) {
            break;
          }
        }
      }
      if (chk && this.isEmpty) {
        this.isEmpty = false;
      }
      return chk;
    },
    deleteCommentModal(param) {
      let self = this;
      let msg = self.$i18nUtil.trans("AB005");
      self.confirmModal(msg, (modal) => {
        modal.close();
        let request = {
          url: "/api/cogroup/project/deleteComment",
          method: "post",
          params: param,
        };
        self.COWORK_REST_SIMPLE_ACTION(request).then(response => {
          if (response.errorCode) {
            console.log('/deleteComment errorCode', response.errorCode);
          }
          msg = self.$i18nUtil.trans("TB092");
          param.deleteYn = 1;
          self.toast(msg);
          EventBus.$emit(name, { action: "delete", projectId: self.projectId });
          self.getCommentList();
        });
      }, [{}, {text: self.$i18nUtil.trans("button.delete","삭제") }]);
    },
    confirmModal (msg, callback, labels) {
      let self = this;
      if (!labels) { labels = [{}, {}]; }
      for (let inx in [0, 1]) {
        labels[inx] = labels[inx] || {};
      }
      const modalInfo = {
        obj: self.$modal,
        component: SimpleModal,
        width: "300px",
        modalContent: msg,
        btnList: [ 
          { label: labels[0].text || self.$i18nUtil.trans("button.cancel","취소"), class: labels[0].cls || "btn_ty2", click(modal, e) { 
            modal.close();
            self.CANCEL_EVENT({event: e});
            setTimeout(() => {
              if (self.toggleBtn) { self.toggleBtn.$el.click(); }
            }, 10);
          }},
          { label: labels[1].text || self.$i18nUtil.trans("button.confirm","확인"), class: labels[1].cls || "btn_ty1", click(modal, e) {
            callback(modal, e);
            setTimeout(() => {
              if (self.toggleBtn) { self.toggleBtn.$el.click(); }
            }, 10);
          }},
        ]
      };
      self.showModal(modalInfo);
    },
    alertModal(msg) {
      const modalInfo = {
        obj: this.$modal,
        component: SimpleModal,
        width: "300px",
        modalContent: msg,
        btnList: [ { label: this.$i18nUtil.trans("button.confirm","확인"), class: "btn_ty1", click(modal) { modal.close(); }} ]
      };
      this.showModal(modalInfo);
    },
    toast(toastMsg) {
      let toastInfo = {
        obj: this.$toasted,
        message: toastMsg,
        options: { theme: "toasted-primary", position: "bottom-left", duration: 3000, },
      };
      this.showToast(toastInfo);
    },
    writeComment(param) {
      let self = this;
      if (self.state.blurHandle) {
        clearTimeout(self.state.blurHandle);
        self.state.blurHandle = null;
      }
      if (!param) { param = { commentId: "" }; }
      let element = self.$refs["commentWriteForm" + param.commentId][0];
      let innerText = element.innerText;
      innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
      innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
      if (!innerText) {
        let msg = self.$i18nUtil.trans("AB014");
        self.alertModal(msg);
        return;
      }
      if (self.validateComment(element.innerText, "R" + param.commentId)) {
        let form = self.writeParam;
        for (let k in param) { form[k] = param[k]; }
        form.projectId = self.projectId,
        form.comment = element.innerHTML;

        let userIdList = [];
        let userNameList = [];
        let callFindKeyMap = {};
        for (let inx = 0, list = element.querySelectorAll("[data-user-id]");
          inx < list.length; inx++) {
          userIdList.push(list[inx].getAttribute("data-user-id"));
          userNameList.push(list[inx].getAttribute("data-user-name"));
          callFindKeyMap[list[inx].getAttribute("data-user-id")] = list[inx].getAttribute("data-callEx-id");
        }
        form.targetUserId = userIdList;
        form.targetUserName = userNameList;
        form.parentCommentId = form.commentId;
        form.commentId = "";
        form.callFindKeyMap = callFindKeyMap;

        let data = {
          url: "/api/cogroup/project/writeComment",
          method: "post",
          params: form,
        };

        self.COWORK_REST_SIMPLE_ACTION(data).then(resp => {
          if (!resp) { return; }
          if (resp.errorCode) { alert(resp.errorCode); }
          element.innerHTML = "";
          self.viewHidden("write", param.commentId, true);
          self.getCommentList({ goto: 0 });
        });
      }
    },
    viewHidden(type, commentId, ignoreConfirm = false) {
      let self = this;
      if (self.state.blurHandle) {
        clearTimeout(self.state.blurHandle);
        self.state.blurHandle = null;
      }
      if (type == "write") {
        let list = self.$refs["commentWriteBox" + commentId];
        let fnToggle = (() => {
          if (list) {
            list.forEach(el => { el.classList.toggle("hidden"); });
          }
          self.$refs["commentWriteForm" + commentId][0].innerHTML = "";
          self.$refs["warnMsgR" + commentId].forEach(el => { el.classList.add("hidden"); });
          self.$refs["usageMsgR" + commentId][0].classList.remove("hidden");
          self.$refs["commentBtnBarR" + commentId][0].classList.add("hidden");
        });
        if ((!list || !list[0].classList.contains("hidden")) && !ignoreConfirm) {
          let msg = self.$i18nUtil.trans("AB004");
          self.confirmModal(msg, (modal) => {
            modal.close();
            fnToggle();
          }, [{}, {text: self.$i18nUtil.trans("button.delete","삭제") }]);
        }
        else {
          fnToggle();
        }
      }
      else if (type == "update") {
        let list = self.$refs["commentEditBox" + commentId];
        list.forEach(el => { el.classList.toggle("hidden"); });
        if (list[0].classList.contains("hidden")) {
          self.$refs["commentEditForm" + commentId][0].innerHTML = self.commentMap[commentId].comment.comment;
          self.$refs["warnMsg" + commentId].forEach(el => { el.classList.add("hidden"); });
          self.$refs["commentBtnBar" + commentId][0].classList.add("hidden");
        }
      }
      if (!self.memberSelector.$el.classList.contains("hidden")) {
        self.memberSelector.cancelMemberSelect(self.state.inputTarget);
        self.memberSelector.cancelMemberSelect(self.$refs.searchInput);
      }
    },
    updateComment(param) {
      if (this.state.blurHandle) { clearTimeout(this.state.blurHandle); }
      this.state.blurHandle = "BUTTONCLICK";
      let element = this.$refs["commentEditForm" + param.commentId][0];
      let innerText = element.innerText;
      innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
      innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
      if (!innerText) {
        let msg = this.$i18nUtil.trans("AB014");
        this.alertModal(msg);
        return;
      }
      if (this.validateComment(element.innerText, param.commentId)) {
        let form = this.writeParam;
        for (let k in param) { form[k] = param[k]; }
        form.comment = element.innerHTML;
        let userIdList = [];
        let userNameList = [];
        let callFindKeyMap = {};
        for (let inx = 0, list = element.querySelectorAll("[data-user-id]");
          inx < list.length; inx++) {
          userIdList.push(list[inx].getAttribute("data-user-id"));
          userNameList.push(list[inx].getAttribute("data-user-name"));
          callFindKeyMap[list[inx].getAttribute("data-user-id")] = list[inx].getAttribute("data-callEx-id")
        }
        form.targetUserId = userIdList;
        form.targetUserName = userNameList;
        form.callFindKeyMap = callFindKeyMap;
        let data = {
          url: "/api/cogroup/project/updateComment",
          method: "post",
          params: form,
        };
        this.COWORK_REST_SIMPLE_ACTION(data).then(resp => {
          if (!resp) { return; }
          if (resp.errorCode) { alert(resp.errorCode); }
          element.innerHTML = "";
          this.viewHidden("update", param.commentId, true);
          this.getCommentList({ goto: param.commentId });
        });
      }
    },
    commentFocus(e, commentId) {
      if (this.state.blurHandle) {
        clearTimeout(this.state.blurHandle);
        this.state.blurHandle = null;
      }
      let editor = this.$refs["commentWriteForm" + commentId][0];
      let sample = this.$refs["mentionSample" + commentId];
      let btnBar = this.$refs["commentBtnBarR" + commentId];
      let innerText = editor.innerText;
      innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
      innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
      if (e.target) {
        e.target.classList.add("hidden");
        if (sample && sample[0] && !innerText) {
          editor.innerHTML = sample[0].innerHTML;
          btnBar[0].classList.remove("hidden");
        }
        editor.focus();
        if (editor.innerHTML && editor.childElementCount > 0) {
          setTimeout(() => {
            document.getSelection().collapse(editor.lastChild, 1);
          }, 100);
        }
      }
    },
    validateComment(text, commentId) {
      this.state.inputLength = text.length;
      let warnMsg = this.$refs["warnMsg" + commentId];
      warnMsg.forEach(el => { el.classList.add("hidden"); });
      if (text.length > 500) {
        warnMsg[0].classList.remove("hidden");
        // console.log("의견은 500글자 이상 작성하실수 없습니다.", el);
        return false;
      }
      if (text.length < 1) {
        return false;
      }
      return true;
    },
    commentKeyUp(e, commentId) {
      /* IE관련 키이벤트를 받기 위해 UP,DOWN 추가 */
      this.processKey(e, commentId, () => 
        { this.memberSelector.editorKeyUp(e); });
    },
    commentKeyDown(e, commentId) {
      let self = this;
      let target = e.target;
      target.$evt = e;
      /* IE관련 키이벤트를 받기 위한편법, MutationObserver를사용한다.*/
      if (!target.$inputObserver) {
        if (target.$inputObserver) { target.$inputObserver.disconnect(); }
        let observer = new MutationObserver((mutationsList, observer) => {
          self.processKey(target.$evt, commentId, () => { self.memberSelector.editorKeyInput(target.$evt); });
        });
        observer.observe(target, { attributes: true, subtree: true, childList: false, characterData: true });
        target.$inputObserver = observer;
      }
      self.processKey(e, commentId, () => {
        self.memberSelector.editorKeyDown(e, {
          positionAdjust: self.memberSelectorPosition, 
          closeCallback: self.memberSelectorSelect,
          inviteCallback(success, userId, companyId, memberList, blockedList) {
            if (self.state.callMemberProcess) {
              if (blockedList != null && blockedList.length > 0) {
                success = false;
                console.log("BLOCKED:", blockedList);
              }
              self.state.callMemberProcess(success);
              delete self.state.callMemberProcess;
            }
            self.$emit("setProjectMemberCount", memberList.length);
          },
          contentEditable: true, autoInvite: 2,
        });
      });
    },
    commentMouseMove(e, type, commentId) {
      let self = this;
      let etype = e.type;

      self.CANCEL_EVENT({event: e});
      if (self.state.blurHandle) {
        clearTimeout(self.state.blurHandle);
        self.state.blurHandle = null;
      }
      // console.log("ETYPE:", etype, e.target.classList);
      if (etype === "mouseout") {
        if (!e.target.classList.contains("hidden")) {
          self.state.blurHandle = setTimeout(() => {
            self.viewHidden(type, commentId, true);
          }, 100);
        }
      }
    },
    commentBlur(e, type, commentId) {
      let self = this;
      self.CANCEL_EVENT({event: e});
      if (self.state.blurHandle) {
        /* 등록 버튼을 먼저 누르고 온 경우 */
        if (self.state.blurHandle == "BUTTONCLICK") {
          self.state.blurHandle = null;
          return;
        }
        clearTimeout(self.state.blurHandle);
        self.state.blurHandle = null;
      }
      self.state.blurHandle = setTimeout(() => {
        let input = null;
        if (type == "write") {
          input = self.$refs["commentWriteForm" + commentId][0];
          let innerText = input.innerText;
          innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
          innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
          if (innerText.length > 0) {
            self.viewHidden(type, commentId);
          }
          else {
            self.$refs["commentWriteForm" + commentId][0].innerText = "";
            self.$refs["usageMsgR" + commentId][0].classList.remove("hidden");
          }
        }
        else if (type == "update") {
          input = self.$refs["commentEditForm" + commentId][0];
        }
        self.memberSelector.cancelMemberSelect(input);
      }, 500);
    },
    processKey(e, commentId, callback) {
      let KEYCODES = this.KEYCODES;
      if (e.target) {
        this.state.inputTarget = e.target;
        if (callback) {
          callback();
        }
        let keyCode = e.keyCode;
        /* 멤버 호출 태그는 편집할수 없도록 */
        if (e.type == this.EVENT_TYPES.KEYDOWN) {
          setTimeout(() => {
            let selection = document.getSelection();
            if (selection.rangeCount == 0) { return; }
            let range = selection.getRangeAt(0);
            let current = range.startContainer;
            let tmpNode1 = current.parentNode;
            let tmpNode2 = current.nextSibling;
            let tmpNode3 = current.previousSibling;
            // console.log("OFFSET:" + keyCode + " / " + range.startOffset + " / " + current.length + " / " + 
            // current + " / " +
            // (tmpNode1 ? tmpNode1.nodeName : "#") + " / " + 
            // (tmpNode2 ? tmpNode2.nodeName : "#") + " / " + 
            // (tmpNode3 ? tmpNode3.nodeName : "#"));
            if (tmpNode1 && tmpNode1.nodeName == "SPAN" &&
              tmpNode1.classList.contains("mention") &&
              tmpNode1.getAttribute("data-user-id")) {
              if (keyCode == KEYCODES.BS) {
                if (tmpNode1.innerText.length <= tmpNode1.getAttribute("data-user-name").length) {
                  tmpNode1.parentNode.removeChild(tmpNode1);
                }
              }
              else if (keyCode == KEYCODES.DEL) {
                tmpNode2 = tmpNode1.nextSibling;
                if (tmpNode1.innerText.length <= tmpNode1.getAttribute("data-user-name").length) {
                  tmpNode1.parentNode.removeChild(tmpNode1);
                }
                if (tmpNode2 && tmpNode2.nodeName == "SPAN" && 
                  tmpNode2.classList.contains("mention") &&
                  tmpNode2.getAttribute("data-user-id") &&
                  tmpNode2.innerText.length <= tmpNode2.getAttribute("data-user-name").length) {
                  tmpNode2.parentNode.removeChild(tmpNode2);
                }
              }
              else if (keyCode == KEYCODES.LEFT) {
                if (range.endOffset < range.endContainer.length) {
                  document.getSelection().collapse(tmpNode1, 0);
                }
              }
              else if (keyCode == KEYCODES.RIGHT) {
                if (range.startOffset > 0) {
                  document.getSelection().collapse(tmpNode1, 1);
                }
              }
              else if (keyCode == KEYCODES.ENTER) {
                if (!this.state.isIE[0]) {
                  let parentNode = tmpNode1.parentNode.parentNode;
                  if (parentNode.lastChild.previousSibling.nodeName == "SPAN") {
                    parentNode.removeChild(parentNode.lastChild.previousSibling);
                  }
                  tmpNode1.innerHTML = "@" + tmpNode1.getAttribute("data-user-name");
                }
                else {
                  let parentNode = tmpNode1.parentNode.previousSibling;
                  if (parentNode.lastChild.nodeName == "SPAN") {
                    parentNode.removeChild(parentNode.lastChild);
                  }
                  tmpNode1.innerHTML = "@" + tmpNode1.getAttribute("data-user-name");
                }
                return;
              }
              else {
                let nextNode = document.createTextNode(" ");
                tmpNode1.innerHTML = "@" + tmpNode1.getAttribute("data-user-name");
                if (tmpNode1.nextSibling) {
                  tmpNode1.parentNode.insertBefore(nextNode, tmpNode1.nextSibling);
                } else {
                  tmpNode1.parentNode.appendChild(nextNode);
                }
                document.getSelection().collapse(nextNode, 1);
              }
            }
            else if (tmpNode2 && tmpNode2.nodeName == "SPAN" &&
              tmpNode2.classList.contains("mention") &&
              tmpNode2.getAttribute("data-user-id")) {
              if (keyCode == KEYCODES.DEL) {
                if (tmpNode2.innerText.length <= tmpNode2.getAttribute("data-user-name").length) {
                  tmpNode2.parentNode.removeChild(tmpNode2);
                }
              }
            }
            /* IE 예외사항. 호출태그 직후 백스페이스시 텍스트가 멘션태그에 병합되는 현상 방지  */
            else if (this.state.isIE[0] &&
              tmpNode1 && tmpNode1.nodeName == "P" &&
              !tmpNode2 && tmpNode3 && tmpNode3.nodeName == "#text" &&
              current.nodeName == "SPAN" &&
              current.classList.contains("mention") &&
              current.getAttribute("data-user-id")) {
              if (keyCode == KEYCODES.BS) {
                let innerText = current.innerText;
                let userName = current.getAttribute("data-user-name");
                let nextNode = document.createTextNode(innerText.substring(
                  userName.length + 1));
                current.innerHTML = "@" + userName;
                current.parentNode.appendChild(nextNode);
                current.parentNode.appendChild(document.createTextNode(" "));
              }
            }
          }, 1);
        }

        let usageMsg = this.$refs["usageMsg" + commentId];
        let btnBar = this.$refs["commentBtnBar" + commentId];
        let innerText = e.target.innerText;
        innerText = innerText.replace(/^[  \t\r\n\0]+/gi, "");
        innerText = innerText.replace(/[  \t\r\n\0]+$/gi, "");
        if (!innerText) {
          if (usageMsg) {
            usageMsg[0].classList.remove("hidden");
          }
          if (btnBar) {
            btnBar[0].classList.add("hidden");
          }
        }
        else {
          if (usageMsg) {
            usageMsg[0].classList.add("hidden");
          }
          if (btnBar) {
            btnBar[0].classList.remove("hidden");
          }
          this.validateComment(e.target.innerText, commentId);
        }
      }
    },
    chkUser(param) {
      if (param.regUserId == this.userId && this.search == "") {
        return true;
      }
      return false;
    },
    memberSelectorPosition(pos, caret) {
      let el = this.$el.parentNode.parentNode.parentNode.parentNode;
      let top = el.offsetTop;
      let left = el.offsetLeft;
      let width = el.offsetWidth;
      let box = caret.parentNode;
      let boxTop = 0;
      let boxLeft = 0;
      let wscrollTop = 0;
      let escrollTop = this.$refs.scrollBox.scrollTop;
      for (; box && !box.getAttribute("contenteditable"); box = box.parentNode ) { }
      if (!box) { return; }
      if (box === this.$refs.commentWriteForm[0]) {
        box = box.parentNode;
        boxTop = box.offsetTop;
        pos.top = top + boxTop + wscrollTop - 25;
      }
      else if (box.classList.contains("reply")) {
        box = box.parentNode;
          boxTop += box.offsetTop;
          boxLeft += box.offsetLeft;
        box = box.parentNode;
          boxTop += box.offsetTop;
        for (let inx = 0; inx < 4; inx++, box = box.parentNode) { }
          boxTop += box.offsetTop;
        pos.top = top + boxTop + wscrollTop - escrollTop - 21;
      }
      else {
        box = box.parentNode;
        boxTop = box.offsetTop;
        box = box.parentNode;
        boxTop+= box.offsetTop;
        pos.top = top + boxTop + wscrollTop - escrollTop - 25;
      }

      /* 홈에서 불린 경우 좌표조정 */
      if (this.callFrom === "projectContents") {
        pos.top += 22;
        if (this.commentList.length == 0) {
          pos.top -= 4;
        }
      }

      // console.log("CHECK:", pos.top + caret.offsetTop, this.state.memberListHeight);
      if ((pos.top + caret.offsetTop - this.state.memberListHeight) < 0) {
        pos.reverse = true;
      }
      pos.left = 10;
      pos.left -= caret.offsetLeft - 20;
    },
    memberSelectorSelect(isCancel, item, caretElement) {
      let self = this;
      /**
       * 멤버 호출시 chinesewall 에 대한 방안
       * 1. 최초 보드 멤버 목록 적재시 차단여부 불러옴
       * 2. 호출 프로세스를 람다콜백으로 선언
       * 3. 멤버에 있고, 차단대상이 아니면 바로 프로세스 실행
       * 4. 멤버에 없다면 람다콜백을 state 에 등록
       * 5. 초대 프로세스 실행하여 성공하면 state 에 등록된 람다콜백 실행
       */
      if (!isCancel && item) {
        let userId = item.getAttribute("data-user-id");
        let userName = item.getAttribute("data-user-name");
        if (userId && userName) {
          let removeTag = () => {
            console.log("REMOVE-TAG");
            let element = caretElement.element;
            let parent = element.parentNode;
            parent.removeChild(element);
            let range = document.getSelection().getRangeAt(0);
            element = range.startContainer.previousSibling;
            document.getSelection().collapse(element, 0);
            self.toast(self.$i18nUtil.trans("message.ProjectComment.001","사용자를 초대할수 없습니다."));
          };
          self.state.callMemberProcess = (success) => {
            console.log("CALL-USER:", userName, success);
            if (success) {
              self.$emit("setProjectMemberCount", self.memberList.length);
            } else {
              setTimeout(removeTag, 100);
            }
          };
          for (let member of self.memberList) {
            if (member.userId == userId) {
              self.state.callMemberProcess(true);
              delete self.state.callMemberProcess;
              break;
            }
          }
        }
      }
    },
    scrollCommentList(e) {
      if (!this.memberSelector.$el.classList.contains("hidden")) {
        this.memberSelector.cancelMemberSelect(this.state.inputTarget);
        this.memberSelector.cancelMemberSelect(this.$refs.searchInput);
      }
    },
    /**
     * 호출 레이어: 멤버 외 사용자 검색 여부
     * 회사 임직원 전체 조회 searchNonMember === true
     * 속한 멤버 내에서 조회 searchNonMember === false
     */
    setSearchNonMember() {
      codeValueJs.getCodeValueList('tenant.env', 'mention.search.nonMember').then(res => {
        let codeValueList = res;
        this.searchNonMember 
          = (codeValueList.length > 0 && codeValueList[0].cdValue === 'false') ? false : true;
      });
    },
    createFindKey(){
      let res = [];
      this.HW_KEYGEN({head: "CMEX", res});
      let callFindKey = res[0];

      return callFindKey;
    }
  },
}
</script>
<style scoped>
#project-comment {
  overflow-y: hidden;
}
#project-comment .scroll_box.writebox {
  height: calc(100% - 150px);
  margin-bottom: 10px;
}
#project-comment .scroll_box.searchbox {
  height: calc(100% - 73px);
  margin-bottom: 50px;
}

#project-comment .write-form > .opinion-input_ty1 {
  position: absolute;
  width: calc(100% - 20px);
  bottom: 20px;
}

#project-comment .scroll_box.searchbox + .write-form {
  display: none;
}

#project-comment .opinion-input_ty1 > div.textarea {
  border: none;
  height: auto;
}

.btn-txt-underline.reply {
  margin-top: 13px;
}

.opinion_box .txt {
  word-break: break-all;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/project/modal/ProjectComment.vue